export type IAppPreviewTab =
  | 'today'
  | 'categories'
  | 'community'
  | 'chat'
  | 'search'
  | 'settings'
  | 'merchmmf'
  | 'merchwp'
  | 'forum';

export type INavigateOptions = {
  props?: Record<string, unknown>;
  animate?: boolean;
};

export type IAppPreviewRoute = {
  appId: string;

  /**
   * Currently available values:
   * - '/'
   * - '/categories/:categoryId'
   * - '/articles/:articleId'
   * - '/community/publicProfile'
   * - '/badges'
   * - '/notificationsSettings'
   * - '/nftAuth'
   * - '/purchased'
   * - '/profile/edit'
   * - '/userArticles/:articleId'
   * - '/tos'
   * - '/modals'
   * - '/contact'
   * - '/validateEmail'
   * - '/apikey'
   * - '/about'
   * - '/pdf/:url'
   */
  path: string;

  tab: IAppPreviewTab;

  navigateOptions?: INavigateOptions;
};

export type IAppPreviewState = {
  iframeRef?: React.RefObject<HTMLIFrameElement>;
  opened: boolean;
  hidden?: boolean;
  url?: string;
  route?: IAppPreviewRoute;
  errorMessage?: string;
  width?: number;
  height?: number;
};

export const initialAppPreviewState: IAppPreviewState = {
  opened: false,
};
